export default class ModalAdminOoCreateClassController {
	/* @ngInject */
	constructor($uibModalInstance, kid, name) {
		this.$uibModalInstance = $uibModalInstance;
		this.disabled = true;
		this.kid = kid;
		this.name = name;
	}

	add() {
		this.$uibModalInstance.close({ kid: this.kid, name: this.name });
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}
}
